import { t } from 'i18next'
import * as yup from 'yup'

/**
 * Form constants
 */

// Section 1
const STATUS = 'status'
const GRADE_COMMENT = 'grade_comment'
const GRADE_PERCENTAGE = 'grade_percentage'

/**
 * Form model
 */
const formModel = () => {
  return {
    [STATUS]: {
      label: `${t('common.status')}`,
      name: STATUS,
    },
    [GRADE_COMMENT]: {
      label: `${t('common.comment')}`,
      name: GRADE_COMMENT,
    },
    [GRADE_PERCENTAGE]: {
      label: `${t('common.grade')}`,
      name: GRADE_PERCENTAGE,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [STATUS]: 'draft',
  [GRADE_COMMENT]: '',
  [GRADE_PERCENTAGE]: '',
}
/**
 * Form data validation
 */
 export const validationSchema = () =>
 yup.object().shape({
    [GRADE_PERCENTAGE]: yup.number().required(`${t('errors.required-error-message')}`),
 })

export default formModel
